module.exports = __webpack_public_path__ + "static/img/bcg_unit5.b59fab7f.png";